import React from 'react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { isValidEmail } from '../../utils/helper';
// import { Tooltip } from "react-tooltip";
import IconCalendar from '../../assets/icons/new_icon/calendar.svg';

interface CustomInputProps {
  id: string;
  label?: string;
  type: string;
  placeholder: string;
  required?: boolean;
  error?: string;
  minLength?: number;
  maxLength?: number;
  value: string;
  onChange: any;
  validating?: boolean;
  tooltipText?: string;
  isDatePicker?: boolean;
  className: string;
  inValid?: boolean;
  sameAddressError?: boolean;
  isVendor?: boolean;
  isDisabled?: boolean;
  minDate?: Date;
}

const CustomInput: React.FC<CustomInputProps> = ({
  id,
  label,
  type,
  placeholder,
  required,
  error,
  minLength,
  maxLength,
  value,
  onChange,
  validating,
  tooltipText,
  isDatePicker,
  className,
  inValid,
  sameAddressError,
  isVendor,
  isDisabled,
  minDate,
}) => {
  let validClass = false;

  if (value && value !== '') {
    validClass = true;
  }
  if (label === 'Email' && value && !isValidEmail(value)) {
    validClass = false;
  }
  if (label === 'Phone' && value && value.length < 10) {
    validClass = false;
  }
  if (label === 'Address' && value && sameAddressError) {
    validClass = false;
  }
  if (inValid) {
    validClass = false;
  }
  return (
    <div className='row mb-3'>
      {/* <Tooltip id="my-tooltip" /> */}
      {label && label !== '' && (
        <label
          className='col-sm-12 col-form-label globalInputLabel my-auto'
          // style={{ width: 'max-content' }}
          data-tooltip-id='my-tooltip'
          // data-tooltip-content={tooltipText ? tooltipText : placeholder}
        >
          {label}{' '}
          {required && (
            <span className='text-danger fw-bold' style={{ marginLeft: '2px' }}>
              *
            </span>
          )}
        </label>
      )}
      <div className='col-sm-12'>
        {isDatePicker ? (
          <DatePicker
            id={id}
            selected={value ? new Date(value) : null}
            onChange={onChange}
            className={className}
            placeholderText={placeholder}
            dateFormat='yyyy-MM-dd'
            autoComplete='off'
            showIcon={true}
            minDate={minDate}
            // icon={IconCalendar}
            calendarIconClassname='calendarIcon'
          />
        ) : isVendor ? (
          <p className={'mb_0'} style={{ marginTop: 6 }}>
            {value}
          </p>
        ) : (
          <input
            id={id}
            className={`${className} ${
              validating && validClass && required
                ? 'is-valid'
                : validating && !validClass && required
                ? 'is-invalid'
                : ''
            } ${
              value && !(validating && !validClass && required)
                ? 'highlighted-border'
                : ''
            }`}
            type={type}
            autoComplete='new-password'
            maxLength={maxLength}
            minLength={minLength}
            value={value}
            placeholder={placeholder}
            onChange={onChange}
            disabled={isDisabled}
          />
        )}
        {/* {inValid && <div className='error_text'>{error}</div>} */}
        {validating && !validClass && !sameAddressError && required && (
          <div className='error_text'>{error}</div>
        )}
        {validating && sameAddressError && (
          <div className='error_text'>
            {'Your destination and origin address are same.'}
          </div>
        )}
      </div>
    </div>
  );
};

export default CustomInput;
